/**
 * Tactile feedback utility for mobile touch interactions.
 * Respects user preferences for reduced motion and device capabilities.
 */
export function triggerHaptic(ms: number = 8): void {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return;
  }

  // Respect reduced-motion accessibility preference
  if (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  // Trigger vibration if supported
  if ('vibrate' in navigator && typeof navigator.vibrate === 'function') {
    try {
      navigator.vibrate(ms);
    } catch {
      // Ignore vibration errors on platforms that restrict navigator.vibrate
    }
  }
}
